export default
  "Conditions générales de vente du pôle Courtage énergie B2B de Solution Éco France — courtier indépendant des fournisseurs d'énergie, mandat écrit, médiateur national de l'énergie.";
